import React, { useEffect, useState, useContext, useMemo } from "react";
import { useTable, useSortBy, useFilters, useColumnOrder } from "react-table";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { StldRow } from "../../../styled-components/StldRow.style";
import { PaginationCustom } from "../../../components/PaginationCustom";
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { StyledTableTimesheet } from "../../../styled-components/StyledTableTimesheet.style";
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { ModalAddProjetoInterno } from "../../../components/ModalAddProjetoInterno";
import Swal from "sweetalert2";
import { getClients } from '../../../services/clientes';
import { getPeritos } from '../../../services/peritos';
import { getEmpresas } from '../../../services/empresas';
import { getDisciplinas } from '../../../services/disciplinas';
import { getAreas, getAreasPI } from '../../../services/areas';
import { get } from "react-hook-form";

let controllerTS;
const requestGetListaProjetosInternos = async (params) => {
    if (controllerTS) {
        controllerTS.abort();
    }

    controllerTS = new AbortController();
    const signal = controllerTS.signal;

    let list = null;
    try {
        const response = await api.get(`ProjetosInternos/list?${params}`, { signal });
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const ProjetoInterno = () => {
    const [projetosInternos, setProjetosInternos] = useState([]);
    const [pageSize, setPageSize] = useState(300);
    const [currentPage, setCurrentPage] = useState(0);
    const [defaultSetted, setDefaultSetted] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const [searchReadOnly, setSearchReadOnly] = useState(false);
    var [searchInput, setSearchInput] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    var [columns, setColumns] = useState([]);
    const [projetosInternoSelected, setProjetosInternoSelected] = useState(null);
    const [clientes, setClientes] = useState(null);
    const [peritosList, setPeritosList] = useState([]);
    const [empresaList, setEmpresaList] = useState([]);
    const [disciplinasList, setDisciplinasList] = useState([]);
    const [areasList, setAreasList] = useState([]);

    const getListaProjetosInternos = async (formValues = null, currentPage = 0, pageSize) => {
        let params = `Start=${currentPage}&Length=${pageSize ?? 300}`;

        if (formValues?.search && formValues?.search?.length > 0) {
            params += `&Search=${formValues.search}`;
        }

        setLoadingData(true);
        const rstData = await requestGetListaProjetosInternos(params);;
        setLoadingData(false);
        return rstData;
    }

    const formData = async (data, currentPage, pageSize, meusTimesheetsParam = false) => {
        let formValues = {
            search: searchInput?.length >= 3 ? searchInput : null,
        };

        setProjetosInternos([]);

        try {
            const TimeSheet = await getListaProjetosInternos(formValues, currentPage, pageSize);

            if (TimeSheet?.data && TimeSheet?.data?.itens?.length > 0) {
                setProjetosInternos(TimeSheet?.data?.itens);
            }
        } catch (error) {
            console.log(error);
        } finally {}
    };

    const getSearch = async (currentValue, value, pageSize = 300, forceidEmpresa = false) => {
        searchInput = (currentValue >= 3) ? currentValue : null;
        setSearchInput(currentValue);

        try {
            let formValues = {
                search: (currentValue?.length >= 3) ? currentValue : '',
            };
            setPageSize(pageSize);

            const TimeSheet = await getListaProjetosInternos(formValues, currentPage, pageSize);
            setProjetosInternos([]);


            if (TimeSheet?.data?.itens && TimeSheet?.data?.itens?.length > 0) {
                setProjetosInternos(TimeSheet?.data?.itens);
                pageSize = TimeSheet.length;
            }
        } catch (e) {}
    };

    const refreshData = async (isNull = false) => {
        let formValues = {
            search: (searchInput?.length >= 3) ? searchInput : ''
        };

        setPageSize(pageSize);
        setProjetosInternos([]);

        try {
            const TimeSheet = await getListaProjetosInternos(formValues, currentPage, pageSize);

            if (TimeSheet.data.itens.length > 0) {
                setProjetosInternos(TimeSheet?.data?.itens);
                pageSize = TimeSheet.length;
            }
        } catch (error) {}
    }

    const getActions = (props) => {
        const row = props.row.original
        return (
            <Flex >
                <span className="cursor-pointer color-icon-default m-1" onClick={() => {
                    setProjetosInternoSelected(row)
                    setIsOpenModalAddProjetoInterno(true)
                }} title="Editar Projeto Interno">
                    <i className="fa fa-edit" aria-hidden="true"></i>
                </span>
                { row.totalTimesheetsRecebidos >= 1 ? <span className="color-icon-default m-1 disabled" title="Recebido"><i className="fa fa-flag"></i></span> :
                    <span className="cursor-pointer color-icon-default m-1" onClick={() => { deleteProjetoInterno(row.idProjetoInterno) }} title="Cancelar">
                        <i className="fa fa-ban"></i>
                    </span>
                }
            </Flex>
        );

    };

    const filterAcoes = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            null
        );
    };

    columns = useMemo(
        () => [
            {
                Header: "Ações",
                accessor: "ac",
                className: "text-left",
                classnameHeader: "width-60",
                sortDescFirst: true,
                Cell: (props) => {
                    return getActions(props);
                },
                Filter: filterAcoes,
            },
            {
                Header: "Sigla",
                accessor: "sigla",
                className: "text-center",
                sortDescFirst: true,
            },
            {
                Header: "Título",
                accessor: "titulo",
                className: "text-center",
                sortDescFirst: true,
            },
            {
                Header: "Descrição",
                accessor: "descricao",
                className: "text-center",
                classNameFooter: "text-center legend-value",
                sortDescFirst: true,
            },
            {
                Header: "Status",
                accessor: "ativo",
                className: "text-center",
                Cell: (props) => { return <div>{ props.value ? 'Ativo' : 'Cancelado'}</div> },
                sortDescFirst: false,                
            }
        ],
        []
    );

    const ColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const getCutText = (text, size) => {
        if (!text) {
            return '';
        }

        return (
            <span title={text}>{reduzirString(text, size)}</span>
        );
    };

    const reduzirString = (texto, limite) => {
        if (texto && texto?.length > limite) {
            return texto.slice(0, limite) + '...';
        } else {
            return texto;
        }
    }

    const defaultColumn = { Filter: ColumnFilter };

    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        footerGroups,
        rows, // rows for the table based on the data passed
        prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
        setColumnOrder
    } = useTable({ columns, data: projetosInternos, defaultColumn }, useFilters, useSortBy, useColumnOrder);

    const getClassRow = (row) => {
        return !row.ativo ?
            ' revisaoCard' : 'align-middle text-center'
    };

    useEffect(() => {
        loadPage()
    }, [null, 0, 10])

    const loadPage = async () => {
        formData(defaultSetted, 0, 300);
    }

    useEffect(() => {
        Promise.all([
            getPeritos(),
            getClients(),
            getEmpresas(),
            getDisciplinas(),
            getAreasPI(),
        ]).then((dataResponse) => {
            setPeritosList(dataResponse[0])
            setClientes(dataResponse[1])
            setEmpresaList(dataResponse[2])
            setDisciplinasList(dataResponse[3])
            setAreasList(dataResponse[4]);
        });
    }, []);

    const [isOpenModalAddProjetoInterno, setIsOpenModalAddProjetoInterno] = useState(false);
    const openModalAddProjetoInterno = () => {
        setProjetosInternoSelected(null)
        setIsOpenModalAddProjetoInterno(true);
    };

    const afterModalAddProjetoInterno = () => { };
    const closeModalCadastroPI = () => {
        setIsOpenModalAddProjetoInterno(false);
    }

    const deleteProjetoInterno = (idProjetoInterno) => {
        Swal.fire({
            title: "Deseja realmente cancelar este projeto interno?",
            text: "Essa ação não poderá ser desfeita!",
            icon: "warning",
            input: 'textarea',
            inputLabel: 'Justifique o cancelamento',
            inputPlaceholder: 'Digite uma observação...',
            inputAttributes: {
                'aria-label': 'Digite uma observação'
            },
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, remover!",
            cancelButtonText: "Cancelar",
            preConfirm: (observacao) => {
                if (!observacao) {
                    Swal.showValidationMessage('Você precisa adicionar uma observação');
                }
                return observacao;
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                const observacao = result.value;
                // Aqui você pode enviar a observação junto com o ID
                deletePrograma(idProjetoInterno, observacao); // Exemplo: ajuste sua função para receber observação
            }
        });
    };
    

    const deletePrograma = async (idProjetoInterno, observacao) => {
        try {
            const payload = {
                idProjetoInterno: idProjetoInterno,
                observacao: observacao
            };

            await api.delete("ProjetosInternos", { data: payload });
            
            Swal.fire({
                title: "Sucesso",
                text: "Projeto Interno Removido com sucesso!",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
            await loadPage()
        } catch (error) {
            Swal.fire({
                title: "Erro",
                text: "Não foi possível remover o programa. Tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Projetos Internos</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                        <div className="">
                            <input className='default-button-red ' value='Adicionar' type="button" onClick={openModalAddProjetoInterno} />
                        </div>
                    </div>
                    <div className="card">
                        <div className="row mb-4">
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput type={'text'} placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} value={searchInput} />
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-9 col-xxl-9">
                                Legenda: <br/>
                                <span className=""><i className="fa fa-ban"></i></span> Pode ser Removido 
                                <span className="ms-2"><i className="fa fa-flag"></i></span> Não pode ser Removido (Possui um Timesheet Recebido)
                            </div>
                        </div>
                        {loadingData ? <StldRow>
                                    <div className="text-center">
                                        <div className="d-flex align-items-center">
                                            <strong style={{ color: "#EE4B21" }}>Atualizando...</strong>
                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        </div>
                                    </div>
                                </StldRow> : ''}
                                <StldRow>
                                    <StyledTableTimesheet>
                                        <div className="timesheet">
                                            <StyledTablePage>
                                                <div className="table-container">
                                                    <table
                                                        {...getTableProps()}
                                                        className="table table-bordered table-width table-sm"
                                                    >
                                                        <thead>
                                                            {headerGroups.map((headerGroup) => (
                                                                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                                    {headerGroup.headers.map((column, index) => (
                                                                        <th
                                                                            {...column.getHeaderProps(
                                                                                column.getSortByToggleProps()
                                                                            )}
                                                                            className={`${column?.classnameHeader} align-middle text-center`}
                                                                        >
                                                                            {column.render("Header")}
                                                                            <span style={{ marginLeft: "3px" }}>
                                                                                {column.isSorted ? (
                                                                                    column.isSortedDesc ? (
                                                                                        <svg
                                                                                            width="12px"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            viewBox="0 0 320 512"
                                                                                        >
                                                                                            <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
                                                                                        </svg>
                                                                                    ) : (
                                                                                        <svg
                                                                                            width="12px"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            viewBox="0 0 320 512"
                                                                                        >
                                                                                            <path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                                                                                        </svg>
                                                                                    )
                                                                                ) : null}
                                                                            </span>
                                                                            <div>
                                                                                {column.canFilter
                                                                                    ? column.render("Filter")
                                                                                    : null}
                                                                            </div>
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            ))}
                                                        </thead>
                                                        <tbody {...getTableBodyProps()}>
                                                            {rows && rows.length > 0 ? rows.map((row, i) => {
                                                                prepareRow(row);
                                                                return (
                                                                    <tr {...row.getRowProps()} className={`table-data-info `} key={'tsTr' + i}>

                                                                        {

                                                                            row.cells.map((cell, i) => {
                                                                                return (
                                                                                    <td  {...cell.getCellProps()} className={`${cell.column.className} ${getClassRow(row?.original)}`} style={{fontSize: '15px'}} >
                                                                                        <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}` + ` ${row?.cells[i].column?.className}`}>
                                                                                            {cell.render("Cell")}
                                                                                        </div>
                                                                                    </td>
                                                                                );
                                                                            })}
                                                                    </tr>
                                                                );
                                                            }) :
                                                                (
                                                                    !loadingData && <tr key={'tsTr' + 999999}>
                                                                        <td colSpan={columns[0]?.columns?.length ?? 12} className="text-center">
                                                                            <div className="alert alert-warning" role="alert">
                                                                                Projeto Interno não foi encontrado. Por favor, adicione um novo.
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                        {/* <tfoot>
                                                            {rows && rows.length > 0 ? footerGroups.map((footerGroup) => (
                                                                <tr {...footerGroup.getFooterGroupProps()} >
                                                                    {footerGroup.headers.map((cell, i) => {
                                                                        if (cell.accessor) {
                                                                            return (
                                                                                <td className={`${cell?.classNameFooter}`} >{cell.Footer && cell.render('Footer')}</td>
                                                                            );
                                                                        }

                                                                    })}
                                                                </tr>
                                                            )) : null}
                                                        </tfoot> */}
                                                    </table>
                                                </div>
                                            </StyledTablePage>
                                        </div>
                                    </StyledTableTimesheet>
                                </StldRow>
                                {(() => {
                                    if (projetosInternos != null) {
                                        return (
                                            <PaginationCustom
                                                isMobile={isMobile}
                                                isDesktop={isDesktop}
                                                length={projetosInternos?.data?.page?.length ?? 0}
                                                recordsTotal={projetosInternos?.data?.page?.recordsTotal ?? 0}
                                                currentPage={currentPage ?? 0}
                                                formData={formData}
                                                pageSize={pageSize ?? 10}
                                                setPageSize={setPageSize}
                                                setPage={(page) => setCurrentPage(page)} />
                                        )
                                    }
                                    return null
                                })()}
                    </div>
                    <br />
                </StyledDefaultPage>
                
            </main >
            <ModalAddProjetoInterno
                isOpen={isOpenModalAddProjetoInterno}
                onAfterOpen={afterModalAddProjetoInterno}
                onRequestClose={closeModalCadastroPI}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                loadPage={loadPage}
                projetoInterno={projetosInternoSelected}
                peritosList={peritosList}
                clientes={clientes}
                empresaList={empresaList}
                disciplinasList={disciplinasList}
                areasList={areasList}
            >
            </ModalAddProjetoInterno>
        </section >
    );
};

export const ProjetoInternoPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <ProjetoInterno />

                </>
            )}
        </>
    );
};